export function formatBrazilianPhoneNumber(phone: string | null): string {
    if (!phone) {
        return '';
    }
    if (phone.length !== 11) {
        throw new Error('Invalid phone number');
    }
    return `(${phone.substring(0, 2)}) ${phone.substring(2, 7)}-${phone.substring(7)}`;
}

export function formatBrazilianZipCode(zip: string | null): string {
    if (!zip) {
        return '';
    }
    return `${zip.substring(0, 5)}-${zip.substring(5)}`;
}

export function formatBrazilianCPForCNPJ(value: string | null): string {
    if (!value) {
        return '';
    }
    if (value.length === 11) {
        // CPF format: 000.000.000-00
        return `${value.substring(0, 3)}.${value.substring(3, 6)}.${value.substring(6, 9)}-${value.substring(9)}`;
    }
    if (value.length === 14) {
        // CNPJ format: 00.000.000/0000-00
        return `${value.substring(0, 2)}.${value.substring(2, 5)}.${value.substring(5, 8)}/${value.substring(8, 12)}-${value.substring(12)}`;
    }
}

export function clearZipCode(zipCode: string): string {

    if (!zipCode)  return '';

    return zipCode.replace(/\D/g, '');
}
